<template>
    <div id="app" :class="{'dark':black,'disableMenu':$store.getters.onEdit}">
        <Popup :active="popup.active" :title="popup.title" :text="popup.text" :btn="popup.btn" @success="popupSuccess" @successSecond="popupSuccessSecond" @error="popupError"></Popup>
        <div id="nav" v-if="$store.getters.isAuthenticated">
            <div id="logo">
                {{$store.getters.getUser.firstname.substr(0,1).toUpperCase()+""+$store.getters.getUser.lastname.substr(0,1).toUpperCase()}}
            </div>
            <ul class="nav" id="menu">
                <li v-if="$store.getters.hasPerm('call:add')" @mouseover="onNavHover('addcall')" @mouseleave="onNavHoverOut" ref="addcall">
                    <router-link to="/call/add" :class="{'active':isRoute('addcall')}" class="ico-addCall"
                                 title="Ajouter un appel">
                        <svg>
                            <use xlink:href="#icon-addCall"></use>
                        </svg>
                    </router-link>
                </li>
                <li v-if="$store.getters.hasPerm('call:list')" @mouseover="onNavHover('calls')" @mouseleave="onNavHoverOut" ref="calls">
                    <router-link to="/calls" :class="{'active':isRoute('calls')}" class="ico-calls"
                                 title="Historique des appels">
                        <svg>
                            <use xlink:href="#icon-calls"></use>
                        </svg>
                    </router-link>
                </li>
                <li v-if="$store.getters.hasPerm('customer:list')" @mouseover="onNavHover('customer')" @mouseleave="onNavHoverOut" ref="customer">
                    <router-link to="/customers" :class="{'active':isRoute('customer')}"
                                 class="ico-users customers" title="Liste des clients">
                        <svg>
                            <use xlink:href="#icon-users"></use>
                        </svg>
                    </router-link>
                </li>
                <li v-if="$store.getters.hasPerm('questionnaire:list')" @mouseover="onNavHover('questionnaire')" @mouseleave="onNavHoverOut" ref="questionnaire">
                    <router-link to="/questionnaires" :class="{'active':isRoute('questionnaire')}"
                                 class="ico-survey questionnaires" title="Liste des questionnaires">
                        <svg>
                            <use xlink:href="#icon-survey"></use>
                        </svg>
                    </router-link>
                </li>
                <li v-if="$store.getters.hasPerm('reason:list')" @mouseover="onNavHover('reason')" @mouseleave="onNavHoverOut" ref="reason">
                    <router-link to="/reasons" :class="{'active':isRoute('reason')}" class="ico-config"
                                 title="Motifs d'appels">
                        <svg>
                            <use xlink:href="#icon-list"></use>
                        </svg>
                    </router-link>
                </li>
                <li v-if="$store.getters.hasPerm('user:list')" @mouseover="onNavHover('user')" @mouseleave="onNavHoverOut" ref="user">
                    <router-link to="/users" :class="{'active':isRoute('user')}" class="ico-users users"
                                 title="Liste des utilisateurs">
                        <svg>
                            <use xlink:href="#icon-users-2"></use>
                        </svg>
                    </router-link>
                </li>
                <span id="navHover" :style="{'top':navHoverTop+'px'}"></span>
            </ul>
            <div class="sub">
                <label class="switch">
                    <input type="checkbox" id="switchDark" @change="toggleBlack($event)" :checked="black">
                    <span class="slider"></span>
                </label>
                <a id="quit" @click="deconnect" href="#">
                    <svg>
                        <use xlink:href="#icon-quit"></use>
                    </svg>
                </a>
            </div>
        </div>
        <transition name="fade" mode="out-in">
            <router-view/>
        </transition>

        <icons-svg></icons-svg>

    </div>
</template>

<script>

    import 'vue-search-select/dist/VueSearchSelect.css'
    import IconsSvg from "@/components/Icons-svg";
    import Popup from "@/components/Popup";
    import tools from "./config.ts";
    import store from "./store/index.ts";

    export default {
        name: "App",
        components: {Popup, IconsSvg},
        store,
        data() {
            return {
                popup: {
                    active: false,
                    title: "Confirmation",
                    text: "Confirmez-vous cette action ?",
                    btn: ['Oui', ''],
                    callbacks: {
                        success: false,
                        successSecond: false,
                        error: false
                    }
                },

                black: false,

                navCurrent:"",
                navHoverTop:0,

                cookies: ["black"],
                loader: false,
            }
        },
        head: {
            title: {
                inner:"Intra",
                complement:"STAPMEDIF"
            },
            link: [
                {rel: "stylesheet", href: "/css/reset.css"},
                {rel: "stylesheet", href: "/css/master.css"},
                {rel: "stylesheet", href: "/css/dark.css"},
                {rel: "stylesheet", href: "/css/responsive.css"},
                {rel: "stylesheet", href: "/css/surcharge.css?t="+(Date.now())},
            ]
        },
        methods: {
            popupOpen(title, text, btn, success, error, successSecond) {
                this.popup.active = true;
                this.popup.title = title || this.popup.title;
                this.popup.text = text || this.popup.text;
                this.popup.btn = btn || this.popup.btn;
                this.popup.callbacks.success = success || this.popup.callbacks.success;
                this.popup.callbacks.successSecond = successSecond || this.popup.callbacks.successSecond;
                this.popup.callbacks.error = error || this.popup.callbacks.error;
            },
            popupSuccess() {

                this.popup.active = false;

                if (!this.popup.callbacks.success) {
                    return false;
                }

                this.popup.callbacks.success();
            },
            popupSuccessSecond() {

                this.popup.active = false;

                if (!this.popup.callbacks.successSecond) {
                    return false;
                }

                this.popup.callbacks.successSecond();
            },
            popupError() {

                this.popup.active = false;

                if (!this.popup.callbacks.error) {
                    return false;
                }

                this.popup.callbacks.error();
            },
            isRoute(route) {

                if(!this.$route.name){
                    return;
                }

                if(this.$route.name.match(route)){
                    this.navCurrent = route;
                    return true;
                }

                return false;
            },
            deconnect() {
                tools.popup("confirm", {
                    message: "Voulez-vous vous déconnecter ?",
                    success: () => {
                        this.$store.commit("deconnect");
                        this.$router.push("login")
                    }
                })
            },
            toggleBlack($event) {
                this.black = $event.target.checked;

                tools.saveCookies("global", this);
            },
            onNavHover($el){
                this.navHoverTop = this.$refs[$el].getBoundingClientRect().top;
            },
            onNavHoverOut(){
                this.navHoverTop = this.$refs[this.navCurrent].getBoundingClientRect().top;
            }
        },
        watch:{
            navCurrent(){
                this.onNavHoverOut()
            }
        },
        mounted() {

            tools.setCookies("global", this);

            tools.$on("popupConfirm", (title, message, btn, success, error, successSecond) => {
                this.popupOpen(title, message, btn, success, error, successSecond);
            });
            tools.$on("popupValid", (title, message, close) => {
                this.popupOpen(title, message, ["Ok"], close);
            });

            tools.resetLocals();
        }
    }
</script>

